import React from 'react';
import style from './index.module.scss';
import {Modal, ModalProps, Table} from 'antd';
import {ColumnProps} from 'antd/es/table';
import {useAtomValue} from 'jotai';
import {paramsInfoAtom} from '../../../../store';
import {ParamsInfo} from '../../../../../../../service';
import {isTrue} from '../../../../../../../../../Utils/common';
import OverLengthColumn from '../../../../../../../Components/OverLengthColumn';

interface AddPlanProps extends ModalProps {
    onCancel: () => void;
}

export default function ParamsShowModal({
    onCancel,
    ...restProps
}: AddPlanProps) {
    const data = useAtomValue(paramsInfoAtom);

    const columns: ColumnProps<ParamsInfo>[] = [
        {
            title: '参数名称',
            dataIndex: 'name',
        },
        {
            title: '类型',
            dataIndex: 'type',
        },
        {
            title: '必填',
            dataIndex: 'required',
            render: (text: BooleanValue) => (
                <div>{isTrue(text) ? '是' : '否'}</div>
            ),
        },
        {
            title: '描述',
            dataIndex: 'desc',
            render: (value: string) => (
                <OverLengthColumn value={value} className={style.position} />
            ),
        },
    ];

    return (
        <Modal
            title="参数说明"
            onCancel={onCancel}
            footer={null}
            {...restProps}
            width={610}
            className={style.root}>
            <Table
                columns={columns}
                rowKey="name"
                dataSource={data}
                pagination={false}
                scroll={{y: 225}}
            />
        </Modal>
    );
}
